import { finalize } from 'rxjs/operators';

(() => {
	angular.module('main').directive('updateLeadModal', updateLeadModal);

	updateLeadModal.$inject = [
		'$rootScope',
		'$route',
		'$location',
		'$timeout',
		'clientsDataService',
		'clientService',
		'messageService',
		'timeService',
		'validationService',
		'leadDataService',
		'leadService',
		'timeConverter',
		'stringModifierService',
		'settingsService',
		'utilsService',
		'leadSourcesDataService',
		'languageDataService',
		'doubleBookingService'
	];

	function updateLeadModal(
		$rootScope,
		$route,
		$location,
		$timeout,
		clientsDataService,
		clientService,
		messageService,
		timeService,
		validationService,
		leadDataService,
		leadService,
		timeConverter,
		stringModifierService,
		settingsService,
		utilsService,
		leadSourcesDataService,
		languageDataService,
		doubleBookingService
	) {
		return {
			restrict: 'E',
			scope: {
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template: `
                <section id="main-wrapper" class="container">
                    <div id="newLead" class="modal modal-center fade" data-backdrop="static" data-keyboard="false"
                         data-autotest-modal="newEditLead">
                        <div class="modal-dialog modal-dialog-datepicker">
                            <div class="modal-content">
                                <form class="form form-horizontal" role="form" ng-submit="addOrUpdateLead(lead.id)">
                                    <div class="modal-header pt-pb-15">
                                        <btn-close ng-click="clearLeadInfo()"></btn-close>
                                        <h3 class="modal-title">{{ lead.id || lead.id === 0 ? 'Edit Lead' : 'Add new
                                            lead' }}</h3>
                                    </div>
                                    <div class="modal-body" style="padding: 30px!important">

                                        <h3 class="mt-0 mb-30">Primary client contact</h3>

                                        <div class="clearfix grey-group-item mb-0 ps-0 text-xs-center text-sm-left">
                                            <div class="col-xs-12 col-sm-2 text-nowrap">
                                                <h4>Choose client</h4>
                                            </div>
                                            <div class="col-xs-12 col-sm-6">
                                                <input placeholder="Start entering client name" class="form-control"
                                                       type="text"
                                                       typeahead="idName as idName.name  for idName in idsNames | filter:$viewValue"
                                                       ng-model="lead.primaryContact">
                                            </div>
                                            <div class="col-xs-12 col-sm-1 row visible-xs-block">
                                                <h4>OR</h4>
                                            </div>
                                            <div class="col-xs-12 col-sm-4 flex-row">
                                                <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>
                                                <button type="button" ng-disabled="button_disable"
                                                        ng-click="createNewClient(0, $event)"
                                                        class="btn btn-info btn-add-new-sm mb-0 fs-14"
                                                        data-autotest-button="addNewClientFirst">Add new client
                                                </button>
                                            </div>
                                        </div>

                                        <div class="clearfix grey-group-item m-30 ps-0 second-client"
                                             ng-show="showSecondClient">
                                            <div class="col-xs-12 col-sm-2 text-nowrap">
                                                <h4>Choose client</h4>
                                            </div>
                                            <div class="col-xs-12 col-sm-6">
                                                <input placeholder="Start entering client name" class="form-control"
                                                       type="text"
                                                       typeahead="idName as idName.name for idName in idsNames | filter:$viewValue"
                                                       ng-model="lead.secondaryContact">
                                            </div>
                                            <div class="col-xs-12 col-sm-1 row visible-xs-block">
                                                <h4>OR</h4>
                                            </div>
                                            <div class="col-xs-12 col-sm-4 flex-row">
                                                <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>
                                                <button type="button" ng-disabled="button_disable"
                                                        ng-click="createNewClient(1, $event)"
                                                        class="btn btn-info btn-add-new-sm mb-0 fs-14"
                                                        data-autotest-button="addNewClientSecond">Add new client
                                                </button>
                                            </div>
                                            <button type="button" class="close" ng-disabled="button_disable"
                                                    ng-click="remove()" data-autotest-button="close">&times;
                                            </button>
                                        </div>

                                        <button type="button" ng-if="!showSecondClient" ng-disabled="button_disable"
                                                ng-click="add()"
                                                class="btn btn-info btn-add-new-sm mt-20"
                                                data-autotest-button="addSecondaryClient">
                                            <span class="hidden-xs fs-14">Add secondary client contact</span>
                                            <span class="visible-xs fs-14">Add secondary</span>
                                        </button>

                                        <hr>
                                        <h3 class="mt-30 mb-25">Lead details</h3>
                                        <div class="row">
                                            <div class="col-sm-2">
                                                <label class="control-label">Lead name:</label>
                                            </div>
                                            <div class="col-sm-8 mb-15">
                                                <input type="text" id="lead-name" class="form-control"
                                                       placeholder="Jenny & Matt"
                                                       ng-model="lead.name" autocomplete="off" maxlength="60" required>
                                            </div>
                                        </div>

                                        <div class="row">

                                            <div class="col-sm-2">
                                                <label class="control-label">Job type:</label>
                                            </div>
                                            <div class="col-sm-8 mb-15">
                                                <div class="select-style">
                                                    <select id="job-type" ng-model="lead.type"
                                                            ng-change="typeChanged(lead.type)"
                                                            ng-options="jobType.name for jobType in lead.jobTypes | orderBy:'name' track by jobType.name">
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-2">
                                                <label class="control-label">Workflow:</label>
                                            </div>
                                            <div class="col-sm-8 mb-15">
                                                <div class="select-style">
                                                    <select ng-options="workflow.name for workflow in lead.workflowNames | orderBy:'name' track by workflow.name"
                                                            ng-model="lead.workflow" ng-disabled="disableWorkflow">
                                                            <option value="" ng-show="disableWorkflow">Default</option>
                                                   </select>


                                                </div>
                                            </div>
                                            <div class="col-sm-8 col-sm-offset-2 select-style-error"
                                                 ng-show="disableWorkflow">
                                                Custom workflow cannot be applied to past jobs.
                                            </div>
                                            <div class="col-sm-8 col-sm-offset-2 select-style-error" ng-if="lead.workflow.automatedTasks">
												This workflow contains automated tasks.
											</div>
                                        </div>

                                        <div class="row" ng-if="leadSourcesAvailable">
											<div class="col-sm-2 pr-0">
												<label class="control-label">Lead Source:</label>
											</div>
											<div class="col-sm-8 mb-15">
												<div class="select-style">
													<select id="lead-type"
															ng-model="lead.leadSource"
															ng-options="leadSource.name for leadSource in leadSources | orderBy:'name' track by leadSource.name"
													 ><option value="">None</option></select>
												</div>
											</div>
                                        </div>
                                        <div ng-if="languages && languages.length > 1" class="row">
                                                  <div class="col-sm-2 pr-0">
                                                      <label class="control-label">Client Portal:</label>
                                                  </div>
                                                  <div class="col-sm-8 mb-15">
                                                      <div class="select-style">
                                                          <select id="lead-language"
                                                                  ng-model="lead.language"
                                                                  ng-options="language.displayName for language in languages | orderBy:'displayName' track by language.name"
                                                          ></select>
                                                      </div>
                                                  </div>
                                                </div>

                                        <hr>
                                        <h3 class="mt-30 mb-25">{{mainShootLabelName}}</h3>

                                        <div class="flex-row mb-25">
                                            <div class="checkbox-squared">
                                                <input type="checkbox" id="noDate" ng-model="lead.hasNoDate"/>
                                                <label for="noDate"></label>
                                            </div>
                                            <label for="noDate">
                                                No date has been confirmed yet
                                            </label>
                                        </div>


                                        <section ng-if="!lead.hasNoDate">

                                            <div class="row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">Date:</label>
                                                </div>

                                                <div class="col-sm-8 job-date">
                                                    <div class="flex-row flex-wrap-xs">
                                                        <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input"  ng-class="{'overlap-warning': !!doubleBookingData}">
                                                            <input ng-model="lead.startDate" class="form-control"
                                                                   ng-change="lead.finishDate = lead.startDate"
                                                                   type="date"
                                                                   name="input"
                                                                   data-placeholder="{{datapickerDateFormat}}"
                                                                   min="2001-12-31"
                                                                   max="2999-12-31"
                                                                   data-date='{"startView": 2, "openOnMouseFocus": true}'
                                                                   required/>
                                                        </div>

                                                        <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>

                                                        <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input"  ng-class="{'overlap-warning': !!doubleBookingData}">
                                                            <input ng-model="lead.finishDate" class="form-control"
                                                                   type="date"
                                                               	   data-placeholder="{{datapickerDateFormat}}"
                                                                   name="input"
                                                                   min="{{( lead.startDate ) ? ( lead.startDate | date : 'yyyy-MM-dd') : (now | date : 'yyyy-MM-dd') }}"
                                                                   max="2999-12-31"
                                                                   data-date='{"startView": 2, "openOnMouseFocus": true}'
                                                                   required/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-sm-2 mb-15 pt-6 flex-row">
                                                    <div class="checkbox-squared">
                                                        <input type="checkbox" id="checkbox-squared-all-lead-day-event"
                                                               ng-model="lead.allday"/>
                                                        <label for="checkbox-squared-all-lead-day-event"></label>
                                                    </div>
                                                    <label for="checkbox-squared-all-lead-day-event">All day</label>
                                                </div>
                                            </div>


                                            <div class="row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">Time:</label>
                                                </div>
                                                <div class="col-sm-8 job-date">
                                                    <div class="flex-row flex-wrap-xs">
                                                    <div class="flex-grow-1 mb-15" ng-class="{'overlap-warning': !!doubleBookingData}">
                                                        <sn-timepicker dom-time="lead_start_time"
                                                                       sn-dr-model="lead.startTime"
                                                                       sn-dr-checked="lead.allday"></sn-timepicker>
                                                    </div>
                                                    <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>
                                                    <div class="flex-grow-1 mb-15" ng-class="{'overlap-warning': !!doubleBookingData}">
                                                        <sn-timepicker dom-time="lead_finish_time"
                                                                       sn-dr-model="lead.finishTime"
                                                                       sn-dr-checked="lead.allday"></sn-timepicker>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>

                </section>


                <div class="flex-row flex-wrap-xs warning-message m-0 mb-25"
                     ng-if="lead.hasNoDate">
               		<warning-sign-img></warning-sign-img>

                    <div class="warning-message__text">
                        <p>This lead has no date:</p>
                        <ul>
                            <li>The {{mainShootLabelName|lowercase}} will not appear in your Calendar.</li>
                            <li>Automated workflow tasks dependent on {{mainShootLabelName|lowercase}} date will not
                                trigger.
                            </li>
                            <li>The %lead_date% variable will display "No date".</li>
                        </ul>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-2">
                        <label class="control-label">Location:</label>
                    </div>
                    <input type="text" class="hide hidden form-control" name="lead.location"
                           ng-model="lead.location"/>
                    <div class="col-sm-8 mb-15 box-no-transition"
                         ng-controller="GoogleAutocompleteController">
                        <input type="text" id="AutocompleteLeadModel" ng-model="lead.location"
                               placeholder=""
                               class="form-control" ng-autocomplete options="options"
                               details="details"/>
                    </div>
                </div>

			    <div class="row" ng-hide="lead.hasNoDate" ng-if="searchingEvents">
					<div class="col-sm-12">
						<div class="db-event-loading mt-10 mb-25">Loading...</div>
					</div>
				</div>
				<div class="row" ng-hide="lead.hasNoDate" ng-if="!searchingEvents && doubleBookingData">
					<div class="col-sm-12 mt-10 mb-25">
						<events-overlapping-info [data]="doubleBookingData"></events-overlapping-info>
					</div>
				</div>


				<div class="row">
					<div class="col-sm-12">
						<hr>
						<h3 class="mt-30 mb-25">Lead Notes:</h3>

						<sn-quill-editor-web
									[init-value]="lead.notes"
									[toolbar-settings]="'color size font'"
									[styles]="{height: '300px'}"
									(on-text-change)="lead.notes = $event">
			   			</sn-quill-editor-web>
					</div>
				</div>

                </div>
                <div class="modal-footer modal-foot">
                    <button type="submit" ng-disabled="button_disable"
                            class="btn btn-success btn-lg"
                            spinning-wheel is-spinning-wheel-active="button_disable"
                    >Save Lead
                    </button>
                    <button type="button" class="btn btn-lg btn-default ml-10"
                            data-dismiss="modal"
                            ng-click="clearLeadInfo()"
                            ng-disabled="button_disabled"
                    >Cancel
                    </button>
                </div>

                </form>
                </div>
                </div>
                </div>
                <create-new-client-modal id="createNewLeadClientModal"
                                         company-name-checked="companyNameChecked"
                                         client="newClient"
                                         save-client="saveClient(event)"
                                         on-close="closeAddClient(event)"
                                      	 is-create-client-modal-spinnning-wheel-active="isCreateClientModalSpinnningWheelActive"
                                      	 business-number-label-name="businessNumberLabelName"
                ></create-new-client-modal>
                </section>

            `,
			replace: true,
			transclude: true,
			link(scope) {
				const defaultWorkflow = {
					id: '',
					name: 'Default'
				};

				let clientsSearchTimer, leadHasNoDate;

				const isNotDefaultWorkflow = workflow =>
					workflow.name !== 'Default' && workflow.id;

				const isDefaultWorkflowInList = list =>
					list.some(item => item.name === 'Default' && item.id === -1);

				scope.$on('showModal', (event, data) => {
					const lead = data.lead;
					scope.lead = angular.copy(data.lead);

					scope.leadSources = [];
					if (scope.lead && scope.lead.leadSource) {
						const { leadSource } = scope.lead;
						if (leadSource.status === 'ARCHIVED') {
							leadSource.name += ' (archived)';
						}
						scope.leadSources.push(leadSource);
					}
					scope.jobId = data.jobId;
					scope.isCreateClientModalSpinnningWheelActive = false;
					scope.searchingEvents = false;
					scope.now = new Date();
					scope.now.setHours(0, 0, 0, 0);
					scope.idsNames = [];
					scope.newClient = {};
					scope.doubleBookingData = null;
					scope.leadSourcesAvailable = true;

					settingsService.timeFormatSettings.subscribe(data => {
						scope.dataFormatMonth = data.dateFormat;
						scope.leadSourcesAvailable = data.leadSourcesAvailable;
					});

					leadSourcesDataService.getActiveLeadSourcesList().subscribe(data => {
						const { leadSource } = scope.lead;
						leadSource && leadSource.status === 'ARCHIVED'
							? (scope.leadSources = [...scope.leadSources, ...data.data])
							: (scope.leadSources = [...data.data]);
					});

					scope.datapickerDateFormat =
						scope.dataFormatMonth === 'DD_MM_YYYY'
							? 'dd/mm/yyyy'
							: 'mm/dd/yyyy';
					if (
						!scope.lead ||
						(scope.lead.secondaryContact === null ||
							scope.lead.secondaryContact === undefined)
					) {
						scope.showSecondClient = false;
					} else {
						scope.showSecondClient = true;
					}

					if (!lead) {
						const defaultType = data.jobTypes.find(
							type => type.default === true
						);
						scope.lead = {
							type: defaultType,
							workflow: defaultType.workflow,
							jobTypes: data.jobTypes,
							workflowNames: data.workflowNames,
							leadSource: null,
							languageNames: data.languageNames
						};
					} else if (lead && !data.jobId) {
						const defaultType = lead.jobTypes.find(
							type => type.default === true
						);

						const defaultValues = {
							type: defaultType,
							workflow: defaultType.workflow
						};
						scope.lead = Object.assign(scope.lead, defaultValues);
					} else if (lead) {
						scope.lead.workflow.name = stringModifierService.addSelectedText(
							scope.lead.workflow.name
						);
						scope.lead.workflowNames.push(scope.lead.workflow);
						leadHasNoDate = scope.lead.hasNoDate;
					}

					if (scope.lead && scope.lead.languageNames) {
						const { selected, availableList } = scope.lead.languageNames;
						scope.lead.language = scope.lead.language || selected;
						scope.languages = availableList || [];
						if (
							scope.lead.language.name &&
							!scope.languages.some(el => el.name === scope.lead.language.name)
						) {
							scope.languages = scope.languages
								.concat(scope.lead.language)
								.sort((a, b) => a.displayName.localeCompare(b.displayName));
						}
					} else {
						scope.languages = [];
					}

					checkLeadDate(scope.lead.startDate);
					$('#newLead')
						.find('input.ws-date')
						.prop('autocomplete', 'off');
				});

				scope.$watch('lead.startDate', checkLeadDate);
				scope.$watch('lead.finishDate', reactToDateTimeChange);
				scope.$watch('lead.finishTime', reactToDateTimeChange);
				scope.$watch('lead.allday', reactToDateTimeChange);

				scope.$watch('lead.startTime', (newValue, oldValue) => {
					if (scope.lead && newValue && newValue !== oldValue) {
						const startTime24 = timeConverter.convert12to24(newValue);
						const startHour = timeService.getHour(startTime24);
						const startMin = timeService.getMinutes(startTime24);

						const finishTime24 = timeConverter.convert12to24(
							scope.lead.finishTime
						);
						const finishHour1 = timeService.getHour(finishTime24);
						if (!scope.lead.id || !scope.lead.finishTime) {
							let finishHour = startHour + 1;

							if (finishHour > 23) {
								finishHour = 0;
							}

							const finishTime = `${finishHour}:${startMin}`;

							scope.lead.finishTime = timeConverter.convert24to12(finishTime);
						}

						if (startHour === finishHour1 - 1 || startHour === finishHour1) {
							let finishHour = startHour + 1;

							if (finishHour > 23) {
								finishHour = 0;
							}

							const finishTime = `${finishHour}:${startMin}`;

							scope.lead.finishTime = timeConverter.convert24to12(finishTime);
						}

						checkForOverlappingEvents();
					}
				});

				scope.$watch('lead.secondaryContact', (newValue, oldValue) => {
					if ( newValue === null || oldValue === newValue || newValue === undefined) {
						return false;
					}

					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(
							findAllMatchingClientNames(newValue),
							500
						);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.$watch('lead.primaryContact', (newValue, oldValue) => {
					if (newValue === null || newValue === undefined || oldValue === newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(
							findAllMatchingClientNames(newValue),
							500
						);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.typeChanged = type => {
					if (scope.lead.id) {
						return;
					}

					if (!scope.disableWorkflow) {
						scope.lead.workflow = type.workflow;
						// const isNotDefault = isNotDefaultWorkflow(type.workflow);
						// if (
						// 	isNotDefault &&
						// 	!isDefaultWorkflowInList(scope.lead.workflowNames)
						// ) {
						// 	scope.lead.workflowNames.push(defaultWorkflow);
						// }
					}
				};

				function setFinishDate(leadStartDate) {
					if (!scope.lead.finishDate || leadStartDate > scope.lead.finishDate) {
						scope.lead.finishDate = leadStartDate;
					}
				}

				function getDefaultWorkflow(workflows) {
					return workflows.find(workflow => workflow.name === 'Default');
				}

				function checkLeadDate(leadStartDate) {
					if (scope.lead && leadStartDate) {
						if (!scope.lead.id) {
							setFinishDate(leadStartDate);
							scope.disableWorkflow = new Date(leadStartDate) < scope.now;

							if (scope.disableWorkflow) {
								scope.lead.workflow = getDefaultWorkflow(
									scope.lead.workflowNames
								);
							}
							checkForOverlappingEvents();
						} else {
							if (scope.lead.hasNoDate) {
								setFinishDate(leadStartDate);
							}
							scope.disableWorkflow = new Date(leadStartDate) < scope.now;
							if (scope.disableWorkflow) {
								scope.lead.workflow = scope.lead.oldWorkflow;
								scope.lead.workflow.id = -1;
							}
						}
					}
				}

				function findAllMatchingClientNames(search) {
					clientsDataService
						.searchClient(search)
						.subscribe(
							data => findClientSuccessCallback(data),
							err => messageService.showDefaultErrorMessage(err)
						);
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.idsNames = [];
						client.forEach(item => scope.idsNames.push(item));
					}
				}

				scope.createNewClient = (clientIndex, event) => {
					scope.newClient = {};
					utilsService.showNextModal(
						'#newLead',
						'#createNewLeadClientModal',
						event
					);
					scope.clientIndex = clientIndex;
				};

				scope.closeAddClient = event => {
					utilsService.showNextModal(
						'#createNewLeadClientModal',
						'#newLead',
						event
					);
				};

				scope.saveClient = event => {
					scope.isCreateClientModalSpinnningWheelActive = true;

					const lowercasedEmail = scope.newClient.email.toLowerCase();
					scope.newClient.email = lowercasedEmail;

					const client2SaveIndex = scope.clientIndex;
					if (!scope.companyNameChecked) {
						delete scope.newClient.companyName;
					}

					if (!validationService.isEmailValid(scope.newClient.email)) {
						scope.isCreateClientModalSpinnningWheelActive = false;
						return messageService.showToaster('e_3', 'companyUsers');
					}

					const clientFirstName = scope.newClient.firstName || '';

					if (!clientFirstName && !clientFirstName.trim()) {
						return messageService.showToaster('e_4', 'clients');
					}

					if (scope.newClient) {
						scope.newClient.notes = $rootScope.addMaiStyling(
							scope.newClient.notes
						);
					}

					clientsDataService
						.addNewClient(scope.newClient)
						.finally(
							() => (scope.isCreateClientModalSpinnningWheelActive = false)
						)
						.subscribe(
							data => successAddNewClient(data, client2SaveIndex, event),
							() => messageService.showToaster('e_6', 'clients')
						);
				};

				function successAddNewClient(data, client2SaveIndex, event) {
					if (data.errorMessage) {
						toastr.error(data.errorMessage, 'Error');
						return false;
					}

					scope.isCreateClientModalSpinnningWheelActive = false;

					delete scope.client;

					const clientSearchObj = clientService.fillClientSearchText(data);

					switch (client2SaveIndex) {
						case 0:
							const primaryClientSearchText = angular.copy(clientSearchObj);
							scope.lead.primaryContact = primaryClientSearchText;
							break;
						case 1:
							const secondaryClientSearchText = angular.copy(clientSearchObj);
							scope.lead.secondaryContact = secondaryClientSearchText;
							break;
						default:
							console.error('Unexpected client index');
					}

					messageService.showToaster('s_2', 'clients');
					utilsService.showNextModal(
						'#createNewLeadClientModal',
						'#newLead',
						event
					);
				}

				scope.addOrUpdateLead = () => {
					delete $rootScope.error;

					const leadClients = [
						scope.lead.primaryContact,
						scope.lead.secondaryContact
					];

					const dataToSave = leadService.validateJob(
						scope.lead,
						leadClients,
						scope.lead.id,
						scope.jobId
					);

					if (dataToSave === false) {
						return false;
					}
					scope.button_disable = true;
					editLeadRequest(dataToSave);
				};

				function editLeadRequest(lead) {
					leadDataService
						.editLead(lead)
						.finally(() => {
							scope.button_disable = false;
						})
						.subscribe(
							data => {
								updateIntercom(lead);
								editLeadSuccessCallback(data, lead.id);
							},
							err => editLeadErrorCallback(err)
						);
				}

				function updateIntercom(lead) {
					const metadata = {
						lead_name: lead.name,
						lead_scheduled: lead.startDate
					};
					Intercom('trackEvent', 'created lead', metadata);
				}

				function editLeadSuccessCallback(data, leadId) {
					if (leadId === null || leadId === undefined) {
						messageService.showToaster('s_4', 'lead');
						$('#newLead').modal('hide');
					} else {
						messageService.showToaster('s_3', 'lead');
						$('#newLead').modal('hide');
						leadSourcesDataService.updateLeadSourcesEvent(true);
					}

					if (data.id && !leadId) {
						$timeout(() => {
							$location.path(`/leads/view/${data.id}`);
						}, 300);
					} else if (scope.updateParent) {
						scope.updateParent({ resetPagination: false });
					} else {
						$timeout(() => {
							$route.reload();
						}, 300);
					}
				}

				function editLeadErrorCallback(err) {
					const {data, status, error} = err;

					if (error && error.errorCode === 102) {
						const { errorTitle, errorMessage } = error;
						messageService.showErrorFromBackend(errorTitle, errorMessage);
					} else {
						const errorMessage = data ? data.errorMessage : null;

						let errorCode, errorPlace;

						if (errorMessage && status >= 400 && status < 500) {

							if (
								status === 422 &&
								errorMessage.includes(
									'Job contact can not be changed because invoices have Xero payment'
								)
							) {
								errorCode = 'e_17';
								errorPlace = 'xero';

								messageService.showToaster(errorCode, errorPlace);
							} else {
								messageService.showDefaultErrorMessage(error);
							}
						} else {
							messageService.showDefaultErrorMessage(error);
						}
					}
				}

				scope.remove = function() {
					delete scope.lead.secondaryContact;
					scope.showSecondClient = false;
				};

				scope.clearLeadInfo = () => {
					delete scope.disableWorkflow;
				};

				scope.add = () => {
					const emptyClient = {
						name: ''
					};
					scope.lead.secondaryContact = emptyClient;
					scope.showSecondClient = true;
				};

				function reactToDateTimeChange(newValue, oldValue) {
					if (!newValue) {
						scope.doubleBookingData = null;
					}
					if (
						(scope.lead && (newValue && newValue !== oldValue)) ||
						newValue === false
					) {
						checkForOverlappingEvents();
					}
				}

				function checkForOverlappingEvents() {
					const hasDate = scope.lead.startDate && scope.lead.finishDate;
					const hasTimeOrAllDay =
						scope.lead.allday ||
						(scope.lead.startTime &&
							scope.lead.finishTime &&
							!scope.lead.allday);

					if (hasDate && hasTimeOrAllDay) {
						scope.button_disable = true;
						scope.searchingEvents = true;
						doubleBookingService
							.getOverlappingEvents(
								doubleBookingService.gatherDateTimeData(scope.lead),
								'JOB',
								scope.jobId || scope.lead.jobId
							)
							.pipe(
								finalize(() => {
									scope.searchingEvents = false;
									scope.button_disable = false;
								})
							)
							.subscribe(data => (scope.doubleBookingData = data));
					}
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/updateLeadModal.js